import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login.vue'),
        meta: { title: '登录 - 兜小聘', public: true }
    },
    {
        path: '/home',
        name: 'HomePage',
        component: () => import('@/views/homePage.vue'),
        meta: { title: '首页 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/jobs',
        name: 'Jobs',
        component: () => import('@/views/jobsPage.vue'),
        meta: { title: '找工作 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/talents',
        name: 'Talents',
        component: () => import('@/views/TalentsPage.vue'),
        meta: { title: '找人才 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/part-time',
        name: 'PartTime',
        component: () => import('@/views/PostJobPage.vue'),
        meta: { title: '发布工作 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/full-time-zone',
        name: 'FullTimeZone',
        component: () => import('@/views/FullTimeZone.vue'),
        meta: { title: '全职招聘专区 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/part-time-zone',
        name: 'PartTimeZone',
        component: () => import('@/views/PartTimeZone.vue'),
        meta: { title: '兼职招聘专区 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/job-detail/:id',
        name: 'JobDetail',
        component: () => import('@/views/JobDetail.vue'),
        meta: { title: '职位详情 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/talent-detail/:id',
        name: 'TalentDetail',
        component: () => import('@/views/TalentDetail.vue'),
        meta: { title: '人才详情 - 兜小聘', requiresAuth: true }
    },
    {
        path: '/user-center',
        name: 'UserCenter',
        component: () => import('@/views/UserCenter.vue'),
        meta: { title: '个人中心 - 兜小聘', requiresAuth: true }
    }
]

const router = new VueRouter({
    mode: 'hash',
    routes
})

// // 添加一个标志，避免重复验证
// let isTokenValidated = false
//
// router.beforeEach(async (to, from, next) => {
//     document.title = to.meta.title || '兜小聘 - 专业招聘平台'
//
//     const token = localStorage.getItem('token')
//
//     console.log('路由守卫检查:', {
//         path: to.path,
//         token: token ? '存在' : '无',
//         isTokenValidated: isTokenValidated
//     })
//
//     // 没有 token，且需要登录，去登录页
//     if (!token) {
//         if (to.meta.requiresAuth) {
//             next({ path: '/login', query: { redirect: to.fullPath }})
//         } else {
//             next()
//         }
//         return
//     }
//
//     // 有 token，但访问登录页，跳首页
//     if (to.path === '/login') {
//         next('/home')
//         return
//     }
//
//     // 需要登录的页面，直接放行（token 存在）
//     next()
// })

export default router